<div class="filter-container">
  <div class="filter-header">
    <div class="filter-title mt-1">
      {{ tableFilter().title }}
    </div>
    <lib-button [type]="ButtonType.tertiary" [size]="InputSize.small" (buttonClick)="resetClicked()" i18n>
      Reset
    </lib-button>
  </div>
  <div>
    <lib-typeahead-input
      class="d-block mt-3"
      [loading]="loadingResults()"
      [results]="resultStrings()"
      [showSelectedValue]="false"
      [formControl]="typeaheadFormControl"
      [controlId]="'typeaheadFilterInput'"
      (resultIndexSelected)="resultIndexSelected($event)">
    </lib-typeahead-input>
  </div>
  <div class="mt-3 pill-container" [hidden]="tableFilter().unsavedOptions?.length === 0">
    @for (filterOption of tableFilter().unsavedOptions; track $index) {
      <lib-interactive-pill
        (pillClick)="pillOptionsClicked(filterOption)"
        [showCross]="true"
        [titleText]="filterOption.name"
        [selected]="filterOption.isSelected?.() ?? false">
      </lib-interactive-pill>
    }
  </div>
</div>
